import { useQuery, UseQueryOptions } from 'react-query';

import { DataRoomRepository, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomDocumentsQuery(
	guid: Guid | undefined,
	folderGuid: Guid | undefined,
	defaultGuid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<DataRoomRepository, unknown, DataRoomRepository, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Documents.Root(guid, folderGuid),
		() =>
			folderGuid
				? AxiosUtils.getResponseData<DataRoomRepository>(
						api.get(CerebroApiEndpoints.Documents.Root(guid, folderGuid))
				  )
				: AxiosUtils.getResponseData<DataRoomRepository>(
						api.get(CerebroApiEndpoints.Documents.Root(guid, defaultGuid))
				  ),
		options
	);
}
